export default __webpack_public_path__ + "static/media/dash-01.89515165.png";